import React, { useEffect, useRef } from 'react';

import { BlipChat } from 'blip-chat-widget';

import { keyBlip, linkBlip } from '../../../../../variables';
import { useTheme } from 'styled-components';

interface IBlip {
  email?: string;
  nome?: string;
  telefone?: string;
  onClose?: boolean;
}

const Blip: React.FC<IBlip> = ({ email, nome, telefone, onClose }) => {
  const blipChatRef = useRef(null);
  const theme = useTheme();
  useEffect(() => {
    const initializeBlipChat = () => {
      const blipChat = new BlipChat();
      blipChat
        .withAppKey(keyBlip)
        .withButton({
          color: theme.colors?.blue02,
          icon: '',
        })
        .withCustomCommonUrl(linkBlip)

        .withAccount({
          fullName: nome,
          email: email,
          phoneNumber: telefone,
          extras: { interno: 'aluno' },
        })
        .build();

      blipChatRef.current = blipChat;

      return blipChat;
    };

    const blipChatInstance = initializeBlipChat();

    return () => {
      blipChatInstance.destroy(); // Destruir a instância do BlipChat quando o componente for removido
      localStorage.removeItem('blipSdkUAccount');
    };
  }, []);

  useEffect(() => {
    if (!blipChatRef.current) return;

    if (onClose) {
      const handleBlipChatClose = () => {};

      const script = document.createElement('script');
      script.textContent = `
        if (window.addEventListener) {
          window.addEventListener("blip-chat-widget-closed", ${handleBlipChatClose});
        } else {
          window.attachEvent("onBlipChatWidgetClosed", ${handleBlipChatClose});
        }
      `;

      document.body.appendChild(script);

      return () => {
        if (window.removeEventListener) {
          window.removeEventListener(
            'blip-chat-widget-closed',
            handleBlipChatClose,
          );
        }

        document.body.removeChild(script);
      };
    }
  }, [onClose]);

  return <></>;
};

export default Blip;
